import { render, staticRenderFns } from "./technical-sheet.vue?vue&type=template&id=aaf39194&scoped=true&"
import script from "./technical-sheet.vue?vue&type=script&lang=js&"
export * from "./technical-sheet.vue?vue&type=script&lang=js&"
import style0 from "./technical-sheet.vue?vue&type=style&index=0&id=aaf39194&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf39194",
  null
  
)

export default component.exports